<template>
  <div class="apps-layout">
    <template v-for="(routes,index) in $router.options.routes">
    <div class="apps-icon-navs" :class="{'blur': !$parent.logined || isBlur}" v-if="routes.visible" :key="index">
      <template v-for="(route,ind) in routes.children">
        <a href="javascript:void(0);" @click="routeTo(route)" v-if="route.visible && !isDisabled(route)" :key="ind" class="nav-link" :class="{'debug':route.meta.debug && $route.query.debug == 'true'}">
          <Badge :count="countNumber(route.name)">
            <div class="nav-item" :style="navItemStyle(route)">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#'+route.icon"></use>
              </svg>
            </div>
          </Badge>
          <span class="nav-title">{{route.title}}</span>
        </a>
      </template>
      <!-- <div style="width:100%;text-align:center">
        <router-link  class="mobile-show" to="/collect/data">采集内容 <Icon type="md-arrow-dropright"></Icon></router-link>
      </div> -->
    </div>
    </template>
      <!-- <NewsCard v-if="$store.state.userInfo.role==0 || $store.state.userInfo.role==1"></NewsCard> -->
    <div class="apps-content">
      <keep-alive>
        <transition
          enter-active-class="animated slide-enter-active"
          leave-active-class="animated slide-leave-active"
          @leave="leave"
          @enter="enter"
          >
            <router-view></router-view>
        </transition>
      </keep-alive>
    </div>
    <app-groups :visible.sync="groupsVisible" :title="groupsTitle" :data="groupsData"></app-groups>
    <div class="layout-mask" v-show="maskShow" @click.stop="$router.replace({'path': '/'})"></div>
    <!-- <div style="border-top:1px solid #f9d282;position:absolute;bottom:0;left:0;background:#ffeea8;width:100%;z-index:2;">
      <span class="menu" style="width:30px;height:20px;line-height:20px;z-index:2;left:50%;margin-left:-10px;position:absolute;top:-20px;background:#f9d282;padding:0 10px;" @click="onlineVisible=!onlineVisible"><Icon type="drag"></Icon></span>
      <transition
          enter-active-class="animated slideInUp"
          leave-active-class="animated slideOutDown"
          >
      <div v-show="onlineVisible" style="padding:10px;">当前在线：<span v-for="item in online['hall']" style="margin-right:10px;">{{item}}</span></div>
    </transition>
    </div> -->
  </div>
</template>

<script>
  // import { fetch } from '../fetch/api'

  export default {
    name: 'appsHome',
    data () {
      return {
        online: [],
        groupsVisible: false,
        groupsTitle: '',
        groupsData: [],
        maskShow: false,
        onlineVisible: false,
        isBlur: false
      }
    },
    watch: {
    },
    components: {
      AppGroups: resolve => { require(['../components/AppGroupsComponent'], resolve) }
      // NewsCard: resolve => { require(['../components/NewsCard'], resolve) }
    },
    mounted () {
      this.$layoutVisible = false
    },
    sockets: {
      userlist (list) {
        let json = JSON.parse(list)
        if (!this.online[json.name]) this.online[json.name] = []
        this.online[json.name] = json.users
      },
      pmsg () {
        // this.$Notice.info({
        //   title: '提示',
        //   duration: 5,
        //   desc: msg
        // })
        // if (this.$isNotification) {
        //   var n = new Notification('浙江宇脉科技OA', {
        //     body: msg
        //   })
        //   setTimeout(() => {
        //     n.close()
        //   }, 5000)
        // }
        this.$store.dispatch('updateBadge')
      },
      badgecount (value) {
        // console.log('badgecount')
        let count = JSON.parse(value)
        this.$store.dispatch('setBadge', {key: 'message', 'value': count.message})
        this.$store.dispatch('setBadge', {key: 'quit', 'value': count.quit})
        this.$store.dispatch('setBadge', {key: 'leave', 'value': count.leave})
        this.$store.dispatch('setBadge', {key: 'expense', 'value': count.expense})
      },
      checkuser (value) {
        // console.log('checkuser')
        this.$store.dispatch('setBadge', {key: 'entry', 'value': value})
        // this.$store.dispatch('setBadge', {key: 'reg', 'value': value})
      }
    },
    methods: {
      countNumber (name) {
        let number = 0
        switch (name) {
          case 'Check':
            number = this.$store.state.badge.entry
            break
          case 'applyExpense':
            number = this.$store.state.badge.expense
            break
          case 'appgroups':
            number = this.$store.state.badge.leave + this.$store.state.badge.quit
            break
        }
        return number
      },
      enter () {
        this.$store.dispatch('setMaskShow', true)
        this.maskShow = true
      },
      leave: function () {
        this.maskShow = false
        // this.$store.dispatch('setMaskShow', false)
      },
      isDisabled (route) {
        if (!this.$store.state.logined) {
          return true
        } else {
          let menuPower = true
          if (this.$store.state.userInfo.menus) menuPower = this.$store.state.userInfo.menus.indexOf(route.meta.id) < 0
          return route.disabled || menuPower
        }
      },
      routeTo (route) {
        if (route.group) {
          this.groupsData = route.children
          this.groupsTitle = route.title
          this.groupsVisible = true
        } else {
          this.groupsVisible = false
          let path = route.path
          path = path.replace('/:action?', '')
          path = path.replace('/:id?', '')
          this.$router.push({'path': path})
        }
      },
      navItemStyle (route) {
        if (route.color !== undefined) {
          return {
            'borderColor': route.color
          }
        }
      }
    }
  }
</script>

<style>
  .apps-content{
    width: 100%;
    top: 0;
    left: 0;
    position: fixed;
    padding: 0;
    z-index: 999;
  }
  .apps-layout{display:flex;}
  .layout-mask{position: fixed;width:100%;height:100%;top:0;left:0;overflow:hidden;z-index: 998}
  .apps-icon-navs{
    flex:1;
    z-index: 1;
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;/*flex-start | flex-end | center | space-between | space-around;*/
    align-items: center;
    align-content: center;
    -webkit-transition: all .5s linear 0s;
    transition: all .5s linear 0s;
    padding: 0 40px;
    overflow-y: auto;
    height: calc(100vh - 50px);
  }
  .apps-icon-navs.blur{
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }
  .apps-icon-navs .nav-link{
    display: inline-block;
    margin: 0;
    text-align: center;
    -webkit-transition: all .5s linear 0s;
    transition: all .5s linear 0s;
    width: calc(100%/5);
    margin-bottom: 20px;
  }
  .apps-icon-navs .nav-link.disabled{
    opacity: .4;
  }
  .apps-icon-navs .nav-item{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 100px;
    height: 100px;
    background-color: #fff;
    border-radius: 100%;
    box-shadow: 0 2px 15px rgba(0, 0, 0, .2);
    text-align: center;
    border: 2px solid #7db0ff;
    margin-bottom: 10px;
  }
  .apps-icon-navs .nav-item .icon{
    display: inline-block;
    width: 60%;
    height: 60%;
    margin: 20%;
  }
  .apps-icon-navs .nav-title{
    margin: 0 auto;
    display: block;
    text-align: center;
    font-size: 12px;
    white-space: nowrap;
    background-color: #ddd;
    color: #333;
    padding: 2px 5px;
    border-radius: 3px;
    width: 100px;
  }
  .slide-enter-active {
    height: 100%;
    animation: slide-in .5s;
  }
  .slide-leave-active {
    animation: slide-in .5s reverse;
  }
  @keyframes slide-in {
    0% {
      opacity: 0;
      transform: translateX(150px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
  @media (max-width: 640px) {
    .apps-icon-navs{
      justify-content: flex-start;/*flex-start | flex-end | center | space-between | space-around;*/
      align-items: flex-start;
      align-content: flex-start;
      padding: 80px 20px 20px
    }
    .apps-icon-navs .nav-link{
      width: 30%;
      margin: 0 1.5% 30px;
    }
  }
</style>
